import React, {useCallback, useEffect, useMemo, useState} from 'react'
import './RichTextView.scss'
import {Editable, withReact, Slate} from 'slate-react'
import {
  createEditor,
} from 'slate'
import {withHistory} from 'slate-history'
import PropTypes from "prop-types";

const RichTextView = (props) => {
  const renderElement = useCallback(props => <Element {...props} />, [])
  const renderLeaf = useCallback(props => <Leaf {...props} />, [])
  const editor = useMemo(() => withHistory(withReact(createEditor())), [])
  const [text, setText] = useState(props.text)

  useEffect(() => {
    setText(props.text)
  }, [props])

  const isJson = (str) => {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  const jsonFromText = (str) => {
    if (isJson(str)) {
      return JSON.parse(str)
    }
    // enforce string typing
    str = str + ""
    return [{
      type: 'paragraph',
      children: str.split(" ").map(it => {
        return {text: it}
      }),
    }]
  }

  return (
    <Slate editor={editor} initialValue={jsonFromText(text)}>
      <Editable
        readOnly={true}
        renderElement={renderElement}
        renderLeaf={renderLeaf}
        spellCheck
        className="richtextview-content"
      />
    </Slate>
  )
}

const Element = ({attributes, children, element}) => {
  const style = {textAlign: element.align}
  switch (element.type) {
    case 'block-quote':
      return (
        <blockquote style={style} {...attributes}>
          {children}
        </blockquote>
      )
    case 'bulleted-list':
      return (
        <ul style={style} {...attributes}>
          {children}
        </ul>
      )
    case 'heading-one':
      return (
        <h1 style={style} {...attributes}>
          {children}
        </h1>
      )
    case 'heading-two':
      return (
        <h2 style={style} {...attributes}>
          {children}
        </h2>
      )
    case 'list-item':
      return (
        <li style={style} {...attributes}>
          {children}
        </li>
      )
    case 'numbered-list':
      return (
        <ol style={style} {...attributes}>
          {children}
        </ol>
      )
    default:
      return (
        <p style={style} {...attributes}>
          {children}
        </p>
      )
  }
}

const isValidHttpUrl = (string) => {
  let url;
  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }
  return url.protocol === "http:" || url.protocol === "https:";
}

const Leaf = ({attributes, children, leaf}) => {
  if (leaf.bold) {
    children = <strong>{children}</strong>
  }

  if (leaf.code) {
    children = <code>{children}</code>
  }

  if (leaf.italic) {
    children = <em>{children}</em>
  }

  if (leaf.underline) {
    children = <u>{children}</u>
  }

  if (leaf.link) {
    if (children.props.text && isValidHttpUrl(children.props.text.text)) {
      children = <a target="_blank" href={children.props.text.text}>{children}</a>
    }
  }

  if (leaf.phone) {
    if (children.props.text && children.props.text.text) {
      children = <a href={"tel:" + children.props.text.text}>{children}</a>
    }
  }

  return <span {...attributes}>{children}</span>
}

RichTextView.propTypes = {
  text: PropTypes.string.isRequired,
}

export default RichTextView